module.exports = __webpack_public_path__ + "img/4.8d25cfd7.png";